// extracted by mini-css-extract-plugin
export default {"transferWarningFlash":"IssueTransferDialog-module__transferWarningFlash__c4B1iUB","noResultsContainer":"IssueTransferDialog-module__noResultsContainer__fP2Ahwh"};